import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Registre, RegistreUpdate, RegistreAdd } from './registre.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegistreService {
    private serviceName = 'RegistreService';

    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    //Getters
    private getRegistreURL = this.basePath + environment.interop.urbanism.nomenclatoare.registre.list;
    private getRegistreURLDT = this.basePath + environment.interop.urbanism.nomenclatoare.registre.listDT;
    private getRegistreActiveURL = this.basePath + environment.interop.urbanism.nomenclatoare.registre.listActive;
    private getRegistrePublicURL = this.basePath + environment.interop.urbanism.nomenclatoare.registre.listPublic;

    //Update
    private storeRegistreUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.store;
    private updateRegistreUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.update;
    private changeStatusActiveUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.changeActive
    private changeStatusPublicUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.changePublic
    private changeCurrentNumberUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.updateSequence;
    private changeStatusArhivaUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.changeStatusCerereArchive;

    private deleteRegistreUrl = this.basePath + environment.interop.urbanism.nomenclatoare.registre.delete;

    constructor(private http: HttpClient) { }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    changeCurrentNumber(id: number, data: { current_number: number }) {
        return this.http.put(this.changeCurrentNumberUrl + id, data, this.httpOptions);
    }

    getRegistre() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRegistreURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get registre:', error);
                    return throwError(error);
                })
            );
    }

    getRegistreDT() {
        return this.http.get(this.getRegistreURLDT, this.httpOptions);
    }

    addRegistre(registreName: RegistreAdd) {
        return this.http.post(this.storeRegistreUrl, registreName, this.httpOptions);
    }

    updateRegistre(judet: RegistreUpdate) {
        return this.http.put(this.updateRegistreUrl, judet, this.httpOptions);
    }

    deleteRegistre(registreId: number) {
        return this.http.delete(this.deleteRegistreUrl + registreId);
    }

    getRegistreActive() {
        return this.http.get(this.getRegistreActiveURL, this.httpOptions);
    }

    getRegistrePublic() {
        return this.http.get(this.getRegistrePublicURL, this.httpOptions);
    }

    getRecordsList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRegistreActiveURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request with service ' + this.serviceName, error);
                    return throwError(error);
                })
            );
    }

    changeStatusArhiva(id: number) {
        return this.http.put(this.changeStatusArhivaUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

}

